module.exports = __webpack_public_path__ + "img/error.8e3d7bea.png";